/*
 * Copyright(c) 1995 - 2020 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */

import { Directive } from '@angular/core';
import { Observable } from 'rxjs';
import { KeyboardListNavigationDirective } from './keyboard-list-navigation.directive';
import { KeyboardPipeSource, KeyboardUtils } from './keyboard.utils';

@Directive({
    selector: '[commonKeyboardListNavTab]'
})
export class KeyboardListNavigationTabDirective<T> extends KeyboardListNavigationDirective<T> {
    getNavigationOperator(): (source$: KeyboardPipeSource<T>) => Observable<number> {
        return KeyboardUtils.tabKeyToDirectionOperator;
    }

    getNavigationKeysFilterPredicate(): (event: KeyboardEvent) => boolean {
        return event => KeyboardUtils.isKeyboardAction(event, 'tab');
    }
}
